import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Bproperty from './Bproperty';
import pimage1 from '../images/p1.png';
import pimage2 from '../images/p2.png';
import pimage3 from '../images/p3.png';

function Properties() {
    return (
        <div className='product'>
            <div className='p-heading'>
                <h3>Real-Estate Properties</h3>
                <p>List of properties on KNS&reg; Hold!&#127969;</p>
            </div>
            <div className='p-box'>
            <Carousel infiniteLoop="true" autoPlay interval="4000" transitionTime="1000" swipeable="true">
            <div>
                <Bproperty image={pimage1} name='Al-Mehar #120' price='&#8377;24,56,000/-'/>
            </div>
            <div>
                <Bproperty image={pimage2} name='Sri-Lakshmi #121' price='&#8377;22,30,000/-'/>
            </div>
            <div>
                <Bproperty image={pimage3} name='Albert-Villa #122' price='&#8377;29,60,000/-'/>
            </div>
            </Carousel>
            </div>
        </div>

    )
}

export default Properties;
